import type { Disposable } from '@patsnap/tahiti-core';

/** 输入区与示例演示支持的视觉模式。 */
export type OnboardingInputExampleGuideMode = 'typing-and-gesture' | 'gesture-only';

/** 公共输入区与示例演示的挂载参数。 */
export interface OnboardingInputExampleGuideShowOptions {
    /** 输入框与示例共同所在的整体高亮容器。 */
    groupElement: Element;
    /** 承载打字浮层的输入区；打字模式下必填。 */
    inputElement?: Element;
    /** 承载单次双击手势的第一条示例。 */
    exampleElement: Element;
    /** 当前模块需要使用的演示模式。 */
    mode: OnboardingInputExampleGuideMode;
}

/** 输入区与示例视觉演示挂载器。 */
export interface OnboardingInputExampleGuidePresenter {
    /**
     * 挂载不触发真实业务事件的输入与点击演示。
     * @param options 演示目标和模式。
     * @returns 可幂等清理宿主、定时器和临时样式的句柄。
     */
    show(options: OnboardingInputExampleGuideShowOptions): Disposable;
}

/** 公共输入区与示例视觉演示挂载器的容器标识。 */
export const OnboardingInputExampleGuidePresenter = Symbol('OnboardingInputExampleGuidePresenter');
